import { DataCampaigns } from "../@types";

export const CAMPAIGNS_MODAL_STATE = "[ CAMPAIGNS ] Campaigns Modal State";

export interface ICampaignsModalState {
  type: typeof CAMPAIGNS_MODAL_STATE;
}

export const GET_CAMPAIGN_FOR_UPDATE =
  "[ CAMPAIGNS ] Get Campaign For Update";

export interface IGetCampaignForUpdate {
  type: typeof GET_CAMPAIGN_FOR_UPDATE;
  payload: DataCampaigns;
}

export const IS_CAMPAIGNS_FOR_UPDATE =
  "[ CAMPAIGNS ] Is Campaign For Update";

export interface IIsCampaignForUpdate {
  type: typeof IS_CAMPAIGNS_FOR_UPDATE;
  payload: boolean;
}

export const SWITCH_CAMPAIGNS_REFRESH_TABLE =
  "[ CAMPAIGNS ] Switch Campaigns Refresh Table";

export interface ISwitchCampaignsRefreshTable {
  type: typeof SWITCH_CAMPAIGNS_REFRESH_TABLE;
  payload: boolean;
}

export const SWITCH_CAMPAIGNS_PRODUCTS_REFRESH_TABLE =
  "[ CAMPAIGNS ] Switch Campaigns Products Refresh Table";

export interface ISwitchCampaignsProductsRefreshTable {
  type: typeof SWITCH_CAMPAIGNS_PRODUCTS_REFRESH_TABLE;
  payload: boolean;
}
